import { browser } from '$app/environment'

export function isMobile() {
	const isMobileMediaQuery = '(max-width: 1024px)'
	if (typeof window !== 'undefined' && browser) {
		return window.matchMedia(isMobileMediaQuery).matches
	}
	return false
}
